// extracted by mini-css-extract-plugin
module.exports = {"section":"ServiceGrid_section__mrSRi","heading":"ServiceGrid_heading___Tc8F","grid":"ServiceGrid_grid__IPfxD","icon":"ServiceGrid_icon__fi9gk"};